import ConsistencyOfBehaviour from "./ConsistencyOfBehaviour";

export default ConsistencyOfBehaviour;
